(function () {
  const initSlider = (section) => {
    const sliderEl = section.querySelector(".swiper--featured-cards");
    if (!sliderEl) return;

    const nextBtn = section.querySelector(".heading-group__navigation-button-next");
    const prevBtn = section.querySelector(".heading-group__navigation-button-prev");
    const cardsPerRow = Number(sliderEl.dataset.cardsPerRow || 4);

    const breakpoints = {
      4: {
        576: { slidesPerView: 2 },
        990: { slidesPerView: 3 },
        1200: { slidesPerView: 4 },
      },
      3: {
        576: { slidesPerView: 2 },
        990: { slidesPerView: 3 },
      },
      2: {
        576: { slidesPerView: 2 },
      },
      1: {
        576: { slidesPerView: 1 },
      },
    };

    new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 800,
      watchSlideProgress: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      breakpoints: breakpoints[cardsPerRow],
    });
  };

  const destroySlider = (section) => {
    const slides = section.querySelectorAll(".featured-cards-card");
    const sliderEl = section.querySelector(".featured-cards-layout");

    if (sliderEl?.swiper) sliderEl.swiper.destroy();

    slides.forEach((slide) => {
      slide.removeAttribute("style");
    });
  };

  const initFeaturedCards = (section) => {
    if (!section || !section.classList.contains("section-featured-cards")) {
      return;
    }

    const box = section.querySelector(".featured-cards");
    if (!box) return;

    const layout = box.dataset.layout || "grid";

    if (layout === "slider") {
      initSlider(box);
    } else {
      destroySlider(box);
    }
  };

  initFeaturedCards(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initFeaturedCards(event.target);
  });
})();
